<script>
export default {
  name: 'SidebarButtonMenu',
  props: {
    title: String
  }
};
</script>

<template>
  <div class="sidebar-button-group">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.sidebar-button-group {
  border-top: solid 1px lighten($--color-gray-90, 5%);
  padding: 2rem 1.5rem 0 1.5rem;
  margin-bottom: 1.5rem;

  // Buttons
  /deep/ .el-button {
    width: 100%;
    font-size: $--font-size-small;
    margin: 0 0 0.5rem 0;
  }

  // Text buttons
  /deep/ .el-button.el-button--text {
    color: $--color-gray-40;
    transition: 0.2s color;
    margin-top: 0.25rem;

    &:hover {
      color: $--color-gray-20;
    }

    i {
      margin-right: 0.25rem;
    }
  }

  // Dropdowns
  /deep/ .el-dropdown {
    display: block;

    .el-button {
      width: 100%;
    }

    // Split button dropdowns
    .el-button-group {
      display: flex;

      // Main button
      .el-button {
        width: auto;
        flex: 1 1 auto;
      }

      // Dropdown button
      .el-button:last-child {
        flex: 0 0 auto;
      }
    }
  }
}
</style>
